// extracted by mini-css-extract-plugin
export default {"notification":"AppNotification-notification-1HE6J","side":"AppNotification-side-2aABk","icon":"AppNotification-icon-2PCms","content":"AppNotification-content-3kW4W"};